import { render, staticRenderFns } from "./ReceiveDetails_Total.vue?vue&type=template&id=7b0841e5&"
import script from "./ReceiveDetails_Total.vue?vue&type=script&lang=js&"
export * from "./ReceiveDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports